var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolarHelpBroken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9995 16C14.2087 16 15.9995 14.2091 15.9995 12C15.9995 9.79086 14.2087 8 11.9995 8C9.79037 8 7.99951 9.79086 7.99951 12C7.99951 14.2091 9.79037 16 11.9995 16Z",
    stroke: "#FDA214",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9995 9L18.9995 5M4.99951 19L8.99951 15M8.99951 9L4.99951 5M18.9995 19L14.9995 15",
    stroke: "#FDA214",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.41176 2.33756C11.1071 1.88159 12.8928 1.88229 14.5878 2.33956C19.9228 3.76956 23.0878 9.25256 21.6588 14.5866C20.2288 19.9216 14.7468 23.0866 9.41176 21.6576C4.07677 20.2286 0.911766 14.7456 2.33977 9.41056C2.79108 7.71392 3.68327 6.16691 4.92577 4.92656",
    stroke: "#FDA214",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarHelpBroken);
export default __webpack_public_path__ + "static/media/solar_help-broken.b554d51c983c2b60e45917df10fbf144.svg";
export { ForwardRef as ReactComponent };